import React, { useEffect, useState } from 'react'
import _debounce from 'lodash.debounce'
import './styles.scss'
import { apiInchat } from 'api'
import TextInputField from 'components/Form/TextInputField'
import { lang } from 'utils/helpers'
import { SelectWithLabel } from 'components/Form'
import { orderFilesInchat, typeFilesInchat } from 'constants/inchatConstant'
import { CardFile } from 'components/Sidemenu/SideMenuInChat/components'
import Nixi1Spinner from 'components/Nixi1Spinner'
import NotResult from 'components/common/NotResult'

const Files = ({ conversation, setErrorModal }) => {

  const [filesData, setFilesData] = useState([])
  const [inputSearch, setInputSearch] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [typeFilter, setTypeFilter] = useState({ value: '', label: lang('dashboard_all') })
  const [orderFilter, setOrderFilter] = useState({ value: 'asc', label: lang('dashboard_order_asc') })

  useEffect(() => {
    const debouncedSearchChannel = _debounce((inputSearch, typeFilter, orderFilter) => {
      getData(inputSearch, typeFilter, orderFilter)
    }, 250)
    debouncedSearchChannel(inputSearch, typeFilter, orderFilter)
    return () => {
      debouncedSearchChannel.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputSearch, typeFilter, orderFilter])

  const getData = async (input, type, order) => {
    setIsLoading(true)
    setErrorModal('')
    let body = {
      conversationId: conversation._id,
      orderFilter: order.value,
    }
    if (input) body.name = inputSearch
    if (type.value) body.typeFilter = typeFilter.value
    apiInchat.getFilesConversation(body)
      .then(({ data }) => {
        setFilesData(data.data)
      })
      .catch(() => setErrorModal(lang('dashboard_error_files')))
      .finally(() => setIsLoading(false))
  }

  return (
    <div className='inchat-files-container'>
      <div className='inchat-files-container__header'>
        <TextInputField
          classNameWrapper='text-filter-files'
          name={'search_files'}
          placeholder={`${lang('dashboard_search')}...`}
          value={inputSearch}
          onChange={setInputSearch}
          className={'icon-filter-channel'}
        />
        <div className='inchat-files-container__header--selector'>
          <SelectWithLabel
            classNameWrapper='inchat-files-container__selectors'
            options={typeFilesInchat.map(type => ({
              ...type,
              label: lang(type.label)
            }))}
            value={typeFilter}
            onChange={setTypeFilter}
            placeholder={lang('dashboard_type')}
            labelCustomSelected={lang('dashboard_types')}
            isRequiredAll
          />
          <SelectWithLabel
            classNameWrapper=' inchat-files-container__selectors inchat-files-container__selectors--order'
            options={orderFilesInchat.map(order => ({
              ...order,
              label: lang(`dashboard_order_${order.label}`)
            }))}
            value={orderFilter}
            onChange={setOrderFilter}
            placeholder='Ordenar por'
          />
        </div>
      </div>
      <div
        className={`inchat-files-container__body ${isLoading ? 'inchat-files-container__body--loading' : ''}`}
      >
        {isLoading
          ? <Nixi1Spinner width='30px' height='30px' />
          : filesData.length ? filesData.map(file => (
            <CardFile key={file._id} file={file} />
          )) : <NotResult message={lang('dashboard_no_results_found')} />
        }
      </div>

    </div>
  )
}

export default Files